// Query param carrying the advanced filter bar's tokens, so a link can open the page pre-filtered
// (e.g. `/batch-failures?filter=Investigator,is,jmanus`).
export const FILTER_PARAM = 'filter';

// Applied when the URL carries no ?filter param: hides rows that are still running (restartable)
// or have been explicitly marked ignored.
export const DEFAULT_ADVANCED_TOKENS = [
  'Restartable',
  'is',
  'false',
  'and',
  'Investigation Notes',
  'is not like',
  'ignore'
];
